module.exports = __webpack_public_path__ + "fonts/AvenirLTW02-95Black.505f82fa360d6dbc5d231e5825e58be9.woff";